import {
    SET_ACCESS_TOKEN,
    SET_REFRESH_TOKEN,
    SET_USERNAME
} from '../actions/auth';


const initialState = {
    accessToken: null,
    refreshToken: null,
    username: null
};


export default function appReducer(state = initialState, action) {
    switch (action.type) {
        case SET_ACCESS_TOKEN:
            return {
                ...state,
                accessToken: action.data
            };
        case SET_REFRESH_TOKEN:
            return {
                ...state,
                refreshToken: action.data
            };
        case SET_USERNAME:
            return {
                ...state,
                username: action.data
            };
        default:
            return state;
    }
}